import React from "react";
import { connect } from "react-redux";
import styles from "./styles";
import { IconButton, Typography, Tooltip } from "@material-ui/core";
import AdjuntoIcono from "../../../assets/iconos/attachment-icon.png";
import closeIcon from "../../../assets/iconos/clear-input-icon.png";

const archivoSubido = (props) => {
    const classes = styles();
    const esDescargable = (props.estado.id === 3) | (props.estado.id === 4);
    const claseExtra = esDescargable ? classes.descargable : null;

    return (
        <div className={classes.container}>
            <img
                src={AdjuntoIcono}
                alt="Archivo adjunto"
                className={classes.containerAdjunto}
                style={{ display: props.mostrarIcono ? "block" : "none" }}
            />
            <Tooltip title={props.fileName} aria-label={props.fileName}>
                <Typography
                    className={`${classes.nombreArchivo} ${claseExtra}`}
                    onClick={
                        esDescargable ? props.descargarArchivoHandler : null
                    }
                >
                    {props.fileName.substring(0, 17) +
                        (props.fileName.length > 17 ? "..." : "")}
                </Typography>
            </Tooltip>
            {!props.soloVista && (
                <IconButton
                    onClick={props.borrar}
                    aria-label="Eliminar"
                    size="small"
                    className={classes.containerEliminar}
                    disabled={props.deshabilitadoBorrar}
                >
                    <img src={closeIcon} alt="Eliminar archivo" />
                </IconButton>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    estado: state.nuevaPresentacionReducer.estado,
    soloVista: state.nuevaPresentacionReducer.soloVista,
});

export default connect(mapStateToProps)(archivoSubido);
